import 'styles/Index.scss';
import MLHeader from './components/Header/MLHeader';
import MLFooter from './components/Footer/MLFooter';
import useGetCountryData from './hooks/useGetCountryData';
import useGetLocationData from './hooks/useGetLocationData';
import useSetLocalStorageLanguage from './hooks/useSetLocalStorageLanguage';
import AppLoginModalWrapper from './components/Auth/AppLoginModalWrapper';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { otpModalState } from './recoil/otp/otpModalAtom';
import { useEffect } from 'react';
import { loadingSpinnerState } from './recoil/loadingSpinner/loadingSpinnerAtom';
import FullScreenLoadingSpinner from './components/Common/FullScreenLoadingSpinner';
import * as Sentry from '@sentry/react';
import AppRoutes from './routes/AppRoutes';
import { countryState } from './recoil/country/countryAtom';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    // BrowserTracing deprecated 되었음 -> browserTracingIntegration 세팅
    // https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#sentryreact
    // No react router
    Sentry.browserTracingIntegration(),
    // react router v6
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
    }),
  ],
  release: '1.2.0', // TODO: 라이브 배포 시 최신 버전으로 업데이트(package.json에 명시 버전도 함께 업데이트)
  environment: process.env.REACT_APP_SETTINGS_MODE,
  tracesSampleRate: 1.0,
  // Sentry 'Inbound Data Filters' 에서 'Filter out events coming from localhost' 활성화 가능, 미작동 시 아래 enabled로 구분 가능
  // enabled: process.env.REACT_APP_SETTINGS_MODE !== 'local', // local 환경에선 실행 X
});

function App() {
  const otpModalOpen = useRecoilValue(otpModalState);
  const isLoading = useRecoilValue(loadingSpinnerState);
  const setCountryData = useSetRecoilState(countryState);

  // localStorage에 이미 key, value 존재하면 localStorage, 없으면 해당 api 호출로 값 저장
  const countryData = useGetCountryData('https://country.mubeat.tv/');

  // 배포 환경에서만 실행(local 환경에서 cors error)
  if (process.env.NODE_ENV === 'production') {
    const locationData = useGetLocationData('https://location.mubeat.tv/');
    if (locationData) {
      localStorage.setItem('locationData', JSON.stringify(locationData));
    }
  }

  useSetLocalStorageLanguage();

  // safari 등 상하단 주소창 등 영역 이슈로 vh 재계산
  const setScreenSize = () => {
    let vh = window.innerHeight * 0.01; // 실제 innerHeight를 100으로 나눠서 실제 1vh 체크
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // 창 크기 변할 때 vh 재계산
    window.addEventListener('resize', setScreenSize);

    return () => {
      window.removeEventListener('resize', setScreenSize);
    };
  };

  useEffect(() => {
    setScreenSize();
  }, []);

  // Sentry 유저 정보 전달
  useEffect(() => {
    const userInfo = localStorage.getItem('userInfo');

    if (userInfo) {
      const user = JSON.parse(userInfo);

      Sentry.setUser({
        login: user.login,
        membership: user.membership,
        user_no: user.user_no,
      });
    }
  }, []);

  useEffect(() => {
    if (countryData) {
      localStorage.setItem('countryData', JSON.stringify(countryData));
      setCountryData(countryData);
    }
  }, [countryData]);

  return (
    <div className='App'>
      {isLoading ? <FullScreenLoadingSpinner /> : null}
      <MLHeader />
      <div className={'app-routes-wrapper'}>
        <AppRoutes />
      </div>
      <MLFooter />
      {otpModalOpen ? <AppLoginModalWrapper /> : null}
    </div>
  );
}

export default App;
